<template>
  <div class="content-1">
    <h3>{{ transPeralbaPro.item791 }}</h3>
    <h4>{{ transPeralbaPro.item792 }}</h4>

    <form
      class=""
      id="check-email-form"
      @submit.prevent="handleLogin"
      method="POST"
    >
      <form-input
        fieldName="email"
        :fieldLabel="transPeralbaPro.item793"
        fieldType="email"
        :fieldValue="email"
        :inputPlaceholder="transPeralbaPro.item794"
        :is-required="true"
        :hasError="errorsData.email"
        @updateValue="updateEmailValue"
      />

      <form-input-password
        fieldName="password"
        :fieldLabel="transPeralbaPro.item797"
        :fieldValue="password"
        :inputPlaceholder="transPeralbaPro.item798"
        :is-required="true"
        :hasError="errorsData.password"
        @updateValue="updatePasswordValue"
        @keyup.enter.prevent="handleLogin"
      />

      <input type="hidden" name="sender_id" value="" />
      <input type="hidden" name="platform" value="0" />
      <input type="hidden" name="os_version" value="" />
      <input type="hidden" name="app_version" value="" />

      <div class="d-flex justify-content-between">
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            tabindex="-1"
            class="custom-control-input"
            id="remember-item"
            v-model="remember"
          />
          <label class="ms-1" for="remember-item">{{
            transPeralbaPro.item1191
          }}</label>
        </div>
        <span class="mt-2">
          <a class="forget-password" @click="goToForgetPassword">{{
            transPeralbaPro.item348
          }}</a>
        </span>
      </div>
      <div class="form-group">
        <button
          type="button"
          :disabled="disabledForm"
          class="btn-per-dark w-100"
          @click="handleLogin"
        >
          {{ transPeralbaPro.item795 }}
        </button>
      </div>
      <div class="mt-3">
        <div
          class="alert alert-danger"
          v-for="(error, index) in errorsData"
          :key="index"
        >
          {{ error.msg }}
        </div>
      </div>
    </form>
    <div class="form-group mt-5">
      <h3>{{ transPeralbaPro.item1185 }}</h3>
      <h5>{{ transPeralbaPro.item1184 }}</h5>
      <button type="button" class="btn-per-dark w-100 mb-3" @click="goToWhoAmI">
        {{ transPeralbaPro.item1186 }}
      </button>
      <button type="button" class="btn-per-dark w-100" @click="goToActiveUser">
        {{ transPeralbaPro.item1187 }}
      </button>
    </div>
  </div>
</template>
<script>
import HTTP from "../../../../services/http";
import axios from "../../../../services/axios";
import FormInput from "../../../../components/front/Inputs/FormInput";
import FormInputPassword from "../../../../components/front/Inputs/FormInputPassword";

import navigation from "../mixins/navigation";
export default {
  components: { FormInput, FormInputPassword },
  mixins: [navigation],
  props: [
    "email",
    "routeCheckEmail",
    "disabledForm",
    "transPeralbaPro",
    "routeActivateCustomer",
    "password",
    "routeLogin",
  ],
  data() {
    return {
      errorsData: [],
      remember: false,
      customers: [],
      currentId: "",
    };
  },

  methods: {
    goToActiveUser() {
      window.location.href = this.routeActivateCustomer;
    },
    updateEmailValue(event) {
      this.$emit("updateField", event.value);
    },
    funCheckEmail(e) {
      e.preventDefault();
      this.errorsData = [];

      const csrf = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      let _self = this;
      this.$emit("loading", true);
      axios
        .post(this.routeCheckEmail, {
          email: this.email,
          _token: csrf,
        })
        .then((r) => {
          _self.$emit("loading", false);
          if (r.data.status == 1) {
            this.$emit("changeView", 2);
          } else {
            this.$emit("changeView", 3);
          }
        })
        .catch((e) => {
          _self.$emit("loading", false);
          this.errorsData.push(e.response.data);
        });
    },
    updatePasswordValue(event) {
      this.$emit("updateFieldPassword", event.value);
    },
    validateData() {
      this.errorsData = [];
      let valid = true;
      if (!this.email) {
        valid = false;
        this.errorsData.email = true;
      }
      if (!this.password) {
        valid = false;
        this.errorsData.password = true;
      }
      return valid;
    },
    handleLogin() {
      const validateData = this.validateData();
      if (!validateData) {
        return;
      }
      const csrf = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");

      const sender_id = document.querySelector('input[name="sender_id"]').value;
      const platform = document.querySelector('input[name="platform"]').value;
      const os_version = document.querySelector('input[name="os_version"]').value;
      const app_version = document.querySelector('input[name="app_version"]').value;

      this.$emit("loading", true);
      HTTP.post(this.routeLogin, {
        email: this.email,
        password: this.password,
        sender_id: sender_id,
        platform: platform,
        os_version: os_version,
        app_version: app_version,
        url: this.previous,
        remember: this.remember,
        _token: csrf,
      })
        .then((r) => {
          if (r.data.status == 2) {
            this.customers = r.data.customers;
            this.currentId = r.data.id;
            this.$emit("changeView", 7);
            this.$emit("multiLogin", r.data);
            this.$emit("loading", false);
          } else {
            window.location.href = r.data.url;
          }
        })
        .catch((e) => {
          this.errorsData.push(e.response.data);
          this.$emit("loading", false);
        });
    },
    goToWhoAmI() {
      this.$emit("changeView", 3);
    },
  },
};
</script>
